import classes from './SpaceAssetTypeBadge.module.scss'
import { type SpaceAssetsLabels } from '../types'
import TrackerBadge from '../TrackerBadge/TrackerBadge'
import {
  HiExclamation,
  HiExclamationCircle,
  HiOutlineClipboardCheck,
  HiOutlineDesktopComputer,
  HiOutlineDocumentText
} from 'react-icons/hi'
import {
  Models,
  Suites,
  TestCaseTag,
  TestConfigTag,
  RequirementGroup,
  Requirements,
  TestTools,
  CustomScriptsLayer,
  WebhookNotificationIcon,
  SutTag
} from '../Icons/Icons'

interface Props {
  label: SpaceAssetsLabels
  hasConflict?: boolean
  conflictVariant?: 'warning' | 'error'
  value: number
}

export const iconMap: Record<SpaceAssetsLabels, any> = {
  Models,
  Suites,
  SUTs: HiOutlineDesktopComputer,
  'Test cases': HiOutlineClipboardCheck,
  'Test configs': HiOutlineDocumentText,
  'Test case tags': TestCaseTag,
  'Test config tags': TestConfigTag,
  'SUT tags': SutTag,
  'Requirement groups': RequirementGroup,
  Requirements,
  'Test mgmt tools': TestTools,
  Webhooks: WebhookNotificationIcon,
  'Custom scripts': CustomScriptsLayer
}

const SpaceAssetTypeBadge = ({
  label,
  hasConflict=false,
  conflictVariant='warning',
  value
}: Props) => {
  const Icon = iconMap[label]

  const useConflictedBackground = hasConflict && conflictVariant !== 'error'

  const backgroundClass = useConflictedBackground
    ? classes.ConflictedBackground
    : classes.DefaultBackground

  const badgeClass = [
    classes.SpaceAssetTypeBadge,
    backgroundClass
  ].filter(styleClass => styleClass).join(' ')

  const ConflictIcon = conflictVariant === 'error'
    ? HiExclamationCircle
    : HiExclamation

  const conflictIconClass = conflictVariant === 'error'
    ? classes.errorIcon
    : undefined

  return (
    <div className={badgeClass}>
      <Icon
        aria-hidden
        size={16}
      />
      {label}
      <span className={classes.badgeWrapper}>
        <TrackerBadge
          counter={value}
          variant='grey'
        />
        {
          hasConflict &&
          <ConflictIcon
            aria-hidden
            className={conflictIconClass}
            size={16}
          />
        }
      </span>
    </div>
  )
}

export default SpaceAssetTypeBadge
